import { render } from "./LoginPage.vue?vue&type=template&id=d894f624&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=d894f624&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d894f624"

export default script